import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ap_lang") || "tr");
  useEffect(() => { localStorage.setItem("ap_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "tr" ? "en" : "tr"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
